import styled from 'styled-components';
import Info from '@material-ui/icons/Info';
import { withStyles } from '@material-ui/core/styles';

const StyledInfoIcon = withStyles({
  root: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#007ade',
  },
})(Info);

export const InfoIcon = styled(StyledInfoIcon)``;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 650px;
  background-color: #ededed;
  border-radius: 5px;
  flex-grow: 1;
  padding: 15px;
  overflow: hidden;
`;

export const Menu = styled.div`
  display: flex;
  gap: 8px;
`;

export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0px;
  gap: 10px;
  max-height: 90%;
  overflow: auto;
`;

export const MenuItem = styled.span`
  display: flex;
  gap: 5px;
  align-items: center;
  padding: 0 7px 5px;
  font-family: Poppins;
  font-weight: 400;
  font-size: 14px;
  border-bottom: 2px solid #ededed;
  transition: all 0.3s ease;
  &:hover,
  &.active {
    cursor: pointer;
    font-weight: 600;
    border-bottom: 2px solid #007ade;
    color: #007ade;
  }
  &:active {
    font-weight: 600;
  }
  &:hover svg path,
  &.active svg path {
    stroke: #007ade;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  color: #707070;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e0e0e0;
`;

export const InfoText = styled.span`
  font-size: 12px;
  color: #787678;
  display: flex;
  flex-direction: row;
  gap: 3px;
  align-items: center;
  padding: 0 10px;
  line-height: 14px;
`;
